import { HttpParams } from "@angular/common/http";
import { TableDataFetch } from "../table-data.service";

// eslint-disable-next-line @tseslint/typedef
export const TABLE_DATA_API_CONFIG_TYPES = {
  custom: "custom",
  preDefined: "preDefined"
} as const;
export type TableDataApiConfig<T> = TableDataApiPreDefined | TableDataApiCustom<T>;
export interface TableDataApiPreDefined {
  type: typeof TABLE_DATA_API_CONFIG_TYPES.preDefined;
  url: string;
  options?: TableDataApiOptions;
}
export interface TableDataApiCustom<T> {
  type: typeof TABLE_DATA_API_CONFIG_TYPES.custom;
  fetch: TableDataFetch<T>;
  options?: TableDataApiOptions;
}
export interface TableDataApiOptions {
  httpParams?: HttpParams;
  fieldsToSkip?: string[];
  ignoreFilter?: boolean;
  pageSize?: number;
}
